import { jsxs as r, Fragment as c, jsx as m } from "react/jsx-runtime";
import d from "styled-components";
import "@fcamna/shared-component-foundations";
import "react";
import { u as h } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { c as u } from "./childrenCountCheck-785fa19a.mjs";
const f = 4, l = d.div`
  display: ${(e) => {
  var a, i, t;
  return (t = (i = (a = e == null ? void 0 : e.theme) == null ? void 0 : a.components) == null ? void 0 : i.raisedSurface) == null ? void 0 : t.Wrapper.display;
}};
  flex-direction: ${(e) => {
  var a, i, t;
  return (t = (i = (a = e == null ? void 0 : e.theme) == null ? void 0 : a.components) == null ? void 0 : i.raisedSurface) == null ? void 0 : t.Wrapper.flexDirection;
}};
  gap: ${(e) => {
  var a, i, t;
  return (t = (i = (a = e == null ? void 0 : e.theme) == null ? void 0 : a.components) == null ? void 0 : i.raisedSurface) == null ? void 0 : t.Wrapper.gap;
}};
  height: ${(e) => {
  var a, i, t;
  return (t = (i = (a = e == null ? void 0 : e.theme) == null ? void 0 : a.components) == null ? void 0 : i.raisedSurface) == null ? void 0 : t.Wrapper.height;
}};
  width: ${(e) => {
  var a, i, t;
  return (t = (i = (a = e == null ? void 0 : e.theme) == null ? void 0 : a.components) == null ? void 0 : i.raisedSurface) == null ? void 0 : t.Wrapper.width;
}};
`, o = d.div`
  border-radius: ${(e) => {
  var a, i, t, n;
  return (n = (t = (i = (a = e == null ? void 0 : e.theme) == null ? void 0 : a.components) == null ? void 0 : i.raisedSurface) == null ? void 0 : t.ChildWrapper) == null ? void 0 : n.borderRadius;
}};
  box-shadow: ${(e) => {
  var a, i, t, n;
  return (n = (t = (i = (a = e == null ? void 0 : e.theme) == null ? void 0 : a.components) == null ? void 0 : i.raisedSurface) == null ? void 0 : t.ChildWrapper) == null ? void 0 : n.boxShadow;
}};
  width: ${(e) => {
  var a, i, t, n;
  return (n = (t = (i = (a = e == null ? void 0 : e.theme) == null ? void 0 : a.components) == null ? void 0 : i.raisedSurface) == null ? void 0 : t.ChildWrapper) == null ? void 0 : n.width;
}};
  box-sizing: ${(e) => {
  var a, i, t, n;
  return (n = (t = (i = (a = e == null ? void 0 : e.theme) == null ? void 0 : a.components) == null ? void 0 : i.raisedSurface) == null ? void 0 : t.ChildWrapper) == null ? void 0 : n.boxSizing;
}};
  border: ${(e) => {
  var a, i, t, n;
  return (n = (t = (i = (a = e == null ? void 0 : e.theme) == null ? void 0 : a.components) == null ? void 0 : i.raisedSurface) == null ? void 0 : t.ChildWrapper) == null ? void 0 : n.border;
}};
  background-color: ${(e) => {
  var a, i, t, n;
  return (n = (t = (i = (a = e == null ? void 0 : e.theme) == null ? void 0 : a.components) == null ? void 0 : i.raisedSurface) == null ? void 0 : t.ChildWrapper) == null ? void 0 : n.backgroundColor;
}};
  box-sizing: ${(e) => {
  var a, i, t, n;
  return (n = (t = (i = (a = e == null ? void 0 : e.theme) == null ? void 0 : a.components) == null ? void 0 : i.raisedSurface) == null ? void 0 : t.ChildWrapper) == null ? void 0 : n.boxSizing;
}};
`, S = ({ children: e, className: a }) => {
  const i = h({ label: "Raised Surface" });
  return /* @__PURE__ */ r(c, { children: [
    u({
      children: e,
      componentName: "Raised Surface",
      maxChildren: f
    }),
    /* @__PURE__ */ m(
      l,
      {
        className: a,
        ...i,
        children: e
      }
    )
  ] });
};
S.Container = o;
export {
  S as RaisedSurface
};
